import useTestItemDetailPageController from '../../1_application/test/testItemDetailPageController';
import withAsync from '../../lib/asyncBounrdary/withAsync';
import BoxContainer from '../core/components/box/boxContainer';
import Column from '../core/components/box/column';
import Row from '../core/components/box/row';
import SizedBox from '../core/components/box/sizedBox';
import LXBack from '../core/components/buttons/lxBack';
import { XCenter } from '../core/components/center';
import LXError from '../core/error/lx_error';
import LXSpinner from '../core/spinner/lx_spinner';
import { LXh1 } from '../core/texts/lxText';
import TestItemView from './components/testItemView';

const TestItemDetailPage = () => {
  const t = useTestItemDetailPageController();
  const controllHeader = (
    <Row width="100%" alignItems="center">
      <LXBack></LXBack>
    </Row>
  );

  const ItemName = () => <LXh1>{t.testItem!.name}</LXh1>;

  if (!t.testItem) return <LXSpinner></LXSpinner>;
  return (
    <XCenter>
      <Column>
        <SizedBox height={80}></SizedBox>
        {controllHeader}
        <SizedBox height={60}></SizedBox>
        <ItemName />
        <SizedBox height={40}></SizedBox>
        <BoxContainer>
          <TestItemView
            testItem={t.testItem!}
            propWidth={'180px'}
          ></TestItemView>
        </BoxContainer>
      </Column>
    </XCenter>
  );
};

export default withAsync({
  child: TestItemDetailPage,
  suspenseFallback: <LXSpinner></LXSpinner>,
  errorFallback: <LXError></LXError>,
});
